import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Classroom from './pages/Classroom';
import ClassroomDetail from './pages/ClassroomDetail';
import Mall from './pages/Mall';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import About from './pages/About';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import './App.css';

const { Content } = Layout;

function App() {
  return (
    <Layout className="app-layout">
      <Header />
      <Content className="app-content">
        <Routes>
          {/* 首页 */}
          <Route path="/" element={<Home />} />

          {/* 付费资讯（ICP审核核心） */}
          <Route path="/classroom" element={<Classroom />} />
          <Route path="/classroom/:id" element={<ClassroomDetail />} />

          {/* 情绪商城（EDI审核核心） */}
          <Route path="/mall" element={<Mall />} />
          <Route path="/mall/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:id" element={<OrderDetail />} />

          {/* 通用页面 */}
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* 用户相关（EDI审核必需） */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
      </Content>
      <Footer />
    </Layout>
  );
}

export default App;
